<template>
  <div class="fin-my-news">
    <v-row>
      <v-col class="col-sm-10 col-md-8 col-lg-5 col-xl-4" cols="12">
       <p> Themen, die zu deinen Portfolios & Watchlists passen: </p>
        <!-- TODO use fin-autocomplete -->
        <v-autocomplete
          v-model="values"
          :items="filterItems"
          dense
          chips
          clearable
          flat
          outlined
          small-chips
          label="Schlagwort oder Direktauswahl"
          no-data-text="Leider nicht gefunden"
          multiple
          solo>
          <v-icon class="search-icon" slot="prepend-inner">icon-compare</v-icon>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <!--TODO filter news containing information related to my portfolios and my watchlists -->
        <fin-auto-load-more-news-list :filter="undefined"/>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import FinAutoLoadMoreNewsList from "@/components/common/news/AutoLoadMoreNewsList"

export default {
  name: 'fin-my-news',
  components: {FinAutoLoadMoreNewsList},
  data() {
    return {
      // TODO news filter function
      filterItems: ['Allianz', 'Apple', 'Daimler', 'Google', 'Microsoft'],
      values: null
    }
  }
}
</script>

<style scoped>

</style>
